// En automaticAssignmentSocket.js
import { useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { useDispatch } from 'react-redux';

const SOCKET_SERVER_URL = process.env.REACT_APP_REPORT_URL;
let socket = null;

export function useAutomaticAssignmentSocket() {
  const dispatch = useDispatch();
  const eventHandlersRef = useRef(new Map());

  useEffect(() => {
    if (!socket) {
      socket = io(`${SOCKET_SERVER_URL}/automaticAssignedOrders`);

      socket.on('connect', () => {
        console.log("Conexión establecida con el servidor de sockets");
      });

      socket.on('connect_error', (err) => {
        console.error('Error de conexión al socket:', err);
      });

      // Configurar el manejador global que redirigirá a los manejadores específicos
      socket.on('thereIsAnOrderAssigned', (data) => {
        dispatch({ 
          type: 'CURRENT_ADDRESS_THAT_HAS_BEEN_CHANGED_SOCKET',
          value: data 
        });
        const handlers = eventHandlersRef.current.get('thereIsAnOrderAssigned') || [];
        handlers.forEach(handler => handler(data));
      });
    }

    // Limpieza
    return () => {
      // Solo limpiamos los manejadores específicos de este componente
      eventHandlersRef.current.clear();
    };
  }, []);

  const subscribe = (event, handler) => {
    const handlers = eventHandlersRef.current.get(event) || [];
    if (!handlers.includes(handler)) {
      eventHandlersRef.current.set(event, [...handlers, handler]);
    }

    // Retornar función para desuscribirse
    return () => {
      const updatedHandlers = (eventHandlersRef.current.get(event) || []).filter(h => h !== handler);
      if (updatedHandlers.length > 0) {
        eventHandlersRef.current.set(event, updatedHandlers);
      } else {
        eventHandlersRef.current.delete(event);
      }
    };
  };

  return { subscribe };
}